import React, { useContext, useState } from 'react'
import FieldsListOption from './dataCollections/fieldsListOption';
import GlobalPopUp from '../../../../utility/globalPopUp';
import CreateVariablePopup from './dataCollections/createVariablePopup';
import { Grid, Popover, useMediaQuery } from '@mui/material';
import SaveDataPopup from './dataCollections/saveDataPopup';
import styles from './../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowForm.module.scss'
import globalStyles from "../../../../../assets/styles/global.module.scss";
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../../../context/flowBuilderContext';
import GlobalDeletePopup from '../../../../utility/globalDeletePopup/globalDeletePopup';
import { UserContext, UserContextPayload } from '../../../../../context/userContext';
import agent from '../../../../../services/api';
import { useSearchParams } from 'react-router-dom';
import textStyles from './../../../../../assets/styles/componentStyles/manychatStyles/instagramStepComponent.module.scss'
import { useFlowBuilderStore } from '../../../../../store/flowBuilderStore';


const SaveVariableFormComponents = (props: any) => {
    const { actionData, stepAction } = props;
    const [searchParams] = useSearchParams()
    const [flagAdvancedOptions, setFlagAdvancedOptions] = useState<boolean>(false);
    const [flagSaveDataCollectionPopup, setFlagSaveDataCollectionPopup] = useState<boolean>(false);
    const [fieldsData, setFieldsData] = useState([])
    const [anchorEl, setAnchorEl] = useState<any>(null)
    const GetCustomVariableListApi = useFlowBuilderStore((state) => state.GetCustomVariableListApi)
    const setFlagDataCollectionPopup = useFlowBuilderStore((state) => state.setFlagDataCollectionPopup)
    const flagDataCollectionPopup = useFlowBuilderStore((state) => state.flagDataCollectionPopup)
    const setFlagUpdateFieldData = useFlowBuilderStore((state) => state.setFlagUpdateFieldData)
    const existingCustomVariablePayload = useFlowBuilderStore((state) => state.existingCustomVariablePayload)
    const setFlagDeleteData = useFlowBuilderStore((state) => state.setFlagDeleteData)
    const flagDeleteFieldData = useFlowBuilderStore((state) => state.flagDeleteFieldData)
    const { onChangeCurrentActiveNodeConfig, nodes, currentActiveNodeConfig } = useContext(FlowBuilderContext) as FlowBuilderContextPayload
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload

    const flagSmallScreen = useMediaQuery<boolean>('(min-width: 0px) and (max-width: 900px)');
    let workflow_id = searchParams.get("workflow_id")


    return (
        <Grid item mt={2} className={textStyles.templatesContainer}>
            <div className={`${styles.bodyFormHeadingStyle} ${globalStyles.primaryFontSize} ${globalStyles.primaryFontWeight}`}>Save Data</div>
            <FieldsListOption 
                stepAction={stepAction} 
                actionData={actionData} 
                setFlagAdvancedOptions={setFlagAdvancedOptions}
            />

            {flagSaveDataCollectionPopup &&
                <Popover
                    id={flagSaveDataCollectionPopup ? 'simple-popover' : undefined}
                    open={flagSaveDataCollectionPopup}
                    anchorEl={anchorEl}
                    onClose={() => { setFlagSaveDataCollectionPopup(false); setFlagUpdateFieldData(false) }}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    className={styles.mainBlock}
                >
                    <CreateVariablePopup />
                </Popover>
            }

            {flagAdvancedOptions &&
                <GlobalPopUp
                    open={flagAdvancedOptions}
                    onClose={() => {
                        setFlagAdvancedOptions(false);
                        onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id, { type: "cancel_changes" },
                            {
                                updateType: "editExistingStepAction"
                            }
                        )
                    }}
                    flagBackdrop
                    paperMinWidth={flagSmallScreen ? "310px" : "700px"}
                    paperMaxwidth={flagSmallScreen ? "610px" : "750px"}
                    flagShowCloseIcon={true} 
                    // overflow="hidden"
                    titlePadding='0'
                    handleClose={() => {
                        setFlagAdvancedOptions(false)
                        onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id,
                            { type: "cancel_changes" },
                            {
                                updateType: "editExistingStepAction"
                            }
                        )
                    }}
                >
                    <SaveDataPopup handleClosePopup={() => { setFlagAdvancedOptions(false); }} stepAction={stepAction} actionData={actionData} setFlagAdvancedOptions={setFlagAdvancedOptions} fieldsData={fieldsData} setAnchorEl={setAnchorEl} setFlagSaveDataCollectionPopup={setFlagSaveDataCollectionPopup} />
                </GlobalPopUp>
            }
        </Grid>
    )
}

export default SaveVariableFormComponents
